module.exports = __webpack_public_path__ + "img/loading-item-waiting@3x.fe4ca738.png";